import {Component, OnInit, Injectable} from "@angular/core";
import {UserRegistrationService} from "../../../providers/userRegistration.service";
import {AlertController, NavController, NavParams, LoadingController} from "ionic-angular";
import {LoginComponent} from "../login/login.component";
import {ResendCodeComponent} from "../resend-code/resendCode.component";
import {RegisterComponent} from "../register/register.component";
import { AuthenticationService } from "../../../services/congito";
import { ProjectHomePage } from "../../../pages/project-home/project-home";
import { HttpService } from "../../../services/httpService";

let passwordRegex = RegExp((/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/));



@Component({
    templateUrl: 'confirmRegistration.html',
    providers: [UserRegistrationService],
    selector: 'forgot-password-page ',
})
export class ConfirmRegistrationComponent  implements OnInit {
    password: string;
    passwordConfirm: string;
    ngOnInit(): void {

    }

    constructor(
        public nav: NavController,
        public userRegistration: UserRegistrationService,
        public navParam: NavParams,
        public alertCtrl: AlertController,
        public authService: AuthenticationService,
        public loadingCtrl: LoadingController,
        public httpService: HttpService,
    ) {
        console.log("Entered ConfirmRegistrationComponent");
        // console.log("nav param email: " + this.navParam.get("email"))
    }

    ionViewLoaded() {
        console.log("Entered ionViewDidEnter");
        console.log("email: " + this.navParam.get("email"));
    }

    async onConfirmRegistration() {
        console.log("Confirming registration");
        await this.authService.registerUserPassword(this.password)
        this.httpService.MeteorSubscribe('projectsAcrossAllCompanies')
        this.nav.setRoot(ProjectHomePage)
        this.httpService.refreshSubscriptions();

        const loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 6000,
            enableBackdropDismiss: true,
        });
        loader.present();
        loader.onDidDismiss(()=>{
            this.httpService.refreshSubscriptions();
        })

        // this.userRegistration.confirmRegistration(this.navParam.get("email"), this.confirmationCode, this);
    }
    hasLowerCase(str) {
        return (str&&str.length)?(/[a-z]/.test(str)):false;
    }
    hasUpperCase(str) {
        return (str&&str.length)?(/[A-Z]/.test(str)):false;
    }
    hasNumber(str) {
        return (str&&str.length)?(/\d/.test(str)):false;
    }
    passwordReady(p1, p2){
        return p1===p2 && passwordRegex.test(p1);
    }
    initPasswordReady(p1){
        return passwordRegex.test(p1);
    }
    /**
     * callback
     * @param message
     * @param result
     */
    cognitoCallback(message: string, result: any) {
        if (message != null) { //error
            this.doAlert("Confirmation", message);
        } else { //success
            console.log("Entered ConfirmRegistrationComponent");
            let email = this.navParam.get("email");

            if (email != null)
                this.nav.push(LoginComponent, {
                    'email': email
                });
            else
                this.nav.push(LoginComponent);
        }
    }

    navToResendCode() {
        this.nav.push(ResendCodeComponent);
    }

    navToRegister() {
        this.nav.push(RegisterComponent);
    }

    navToLogin() {
        this.nav.push(LoginComponent);
    }

    doAlert(title: string, message: string) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/auth/confirm-registration/confirmRegistration.component.ts